/**
 * Treydora storefront API origin (TreydoraEdBackend).
 * Env: REACT_APP_API_BASE_URL
 *
 * Production builds require an explicit origin (e.g. https://api.treydora.com).
 * Development falls back to local TreydoraEdBackend.
 */
const DEV_API_BASE_URL = "http://127.0.0.1:8080";

export function getApiBaseUrl() {
  const trimmed = String(process.env.REACT_APP_API_BASE_URL ?? "").trim().replace(/\/+$/, "");
  if (trimmed) return trimmed;
  if (process.env.NODE_ENV === "production") {
    throw new Error(
      "REACT_APP_API_BASE_URL is required for production builds. Set it to your live API origin (e.g. https://api.treydora.com). See .env.example."
    );
  }
  return DEV_API_BASE_URL;
}
